import { generatePath } from 'react-router-dom'

export const reverse = (path, params = {}) => {
    // this will raise a TypeError if params provided do not match the path
    return generatePath(path, params)
}
